'use client';

import { useInsertionEffect, useRef } from 'react';
import { usePathname, useRoutePattern } from '@framework/next/navigation';
import { getContainer } from '@framework/di/getContainer';
import { useOTelTraceContext } from '../react/OTelTraceContext';
import PageTrace from '../PageTrace';

interface IProps {
  pathname?: string,
  route?: () => string,
}

const PageNavigationInstrumentation = ({ pathname, route, children }: React.PropsWithChildren<IProps>) => {
  const nextPathname = usePathname();
  const routePattern = useRoutePattern();
  const page = pathname ?? nextPathname;
  const routeRef = useRef(route ?? (() => routePattern));
  const pageTrace = getContainer().get(PageTrace);
  const pageLoadSpan = useOTelTraceContext(true)?.span;

  useInsertionEffect(() => {
    routeRef.current = route ?? (() => routePattern);
  });

  useInsertionEffect(() => {
    pageTrace.navigate(page, () => routeRef.current(), pageLoadSpan);
  }, [page, pageTrace, pageLoadSpan]);

  return children;
};

export default PageNavigationInstrumentation;
